import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-team-member-row',
  templateUrl: './team-member-row.component.html',
  styleUrl: './team-member-row.component.scss',
  standalone: false
})
export class TeamMemberRowComponent {
  /** Member's first name. */
  @Input() firstName = '';
  /** Member's last name. */
  @Input() lastName = '';
  /** 1 = male, 2 = female (matches the rest of the app's convention). */
  @Input() sex: number | undefined;
  /** Highlights this row (name + total time) as the one that determined the team's result. */
  @Input() determines = false;

  /** Pre-formatted day time value (row.detail?.ps_tm | resultDateTime). */
  @Input() dayTimeText = '';
  /** Pre-formatted pass time value (row.detail?.nt_tm | resultTime). */
  @Input() passTimeText = '';
  /** Pre-formatted total time value (row.detail?.tl_tm or tl_tm_pen | resultTime). */
  @Input() totalTimeText = '';
  /** Show the "(after penalty)" note under the total time — finish only. */
  @Input() showAfterPenaltyNote = false;
  /** This member's own penalty minutes, if any (only ever set for the finish). */
  @Input() penalty: number | undefined;

  @Input() overallRank: string | number | undefined;
  @Input() sexRank: string | number | undefined;
  @Input() categoryRank: string | number | undefined;
}
